import React from "react";
import { FaWhatsapp, FaEnvelope, FaPhone } from "react-icons/fa";

const Contact: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 pt-28 pb-16 bg-transparent text-white relative overflow-hidden">
      {/* Glass Container */}
      <div className="w-full max-w-3xl bg-white/10 backdrop-blur-lg border border-white/20 rounded-2xl shadow-xl p-8 z-10 text-center">
        {/* Header */}
        <h1 className="text-4xl font-bold text-yellow-400 mb-4">📬 Contact Us</h1>
        <p className="text-gray-300 mb-8 text-sm sm:text-base">
          Have questions, feedback, or need support? Reach us anytime via WhatsApp, Email, or Call.
        </p>

        {/* Contact Icons */}
        <div className="flex justify-center space-x-10 text-4xl mb-10">
          <a href="https://wa.me/+917017231643" target="_blank" rel="noopener noreferrer">
            <FaWhatsapp className="text-green-400 hover:text-green-300 transition" />
          </a>
          <a href="mailto:hmgxcarryadder@gmail.com">
            <FaEnvelope className="text-blue-400 hover:text-blue-300 transition" />
          </a>
          <a href="tel:+917017231643">
            <FaPhone className="text-yellow-400 hover:text-yellow-300 transition" />
          </a>
        </div>

        {/* About Us Section */}
        <h2 className="text-2xl font-semibold text-yellow-300 mb-2">About Us</h2>
        <p className="text-white/80 leading-relaxed text-sm sm:text-base">
          We are passionate about creating a smart, trusted matchmaking platform for the Maheshwari community.
          Our mission is to blend tradition with modern intelligence and help you find your most compatible match
          through trust, personalization, and community values.
        </p>
      </div>

      {/* Soft Glowing Background Blobs */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-yellow-400 opacity-10 blur-[140px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-pink-500 opacity-10 blur-[140px] rounded-full" />
    </div>
  );
};

export default Contact;
